import { DesignValidationResultResource, GetDesignsByDesignValidateApiArg, serverApi } from '@/api/serverApi'
import { MaybeApiError } from '@cfs-fixings/shared'
import { type PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '.'

export type DesignValidationSlice = {
  validationResponses: DesignValidationResultResource | null
  validating: boolean
}

const initialState: DesignValidationSlice = {
  validationResponses: null,
  validating: false,
}

export const validateDesign = createAsyncThunk<MaybeApiError, GetDesignsByDesignValidateApiArg, { state: RootState }>(
  'designValidation/validateDesign',
  async ({ design }, thunk) => {
    const result = await thunk.dispatch(serverApi.endpoints.getDesignsByDesignValidate.initiate({
      design: design,
    }, { forceRefetch: true }))


    if ('error' in result) {
      return result.error as MaybeApiError
    }

    if (result.data?.data) {
      thunk.dispatch(designValidationSlice.actions.setValidationResponses(
        result.data.data,
      ))
    }
  },
)

export const designValidationSlice = createSlice({
  name: 'designValidation',
  initialState,
  reducers: {
    setValidationResponses: (state, action: PayloadAction<DesignValidationResultResource>) => {
      state.validationResponses = action.payload
    },
    clearValidationResponses: (state) => {
      state.validationResponses = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateDesign.pending, (state) => {
        state.validating = true
      })
      .addCase(validateDesign.fulfilled, (state) => {
        state.validating = false
      })
  },
})

export const { setValidationResponses } = designValidationSlice.actions

export default designValidationSlice.reducer
